import type { FaireProductEntity } from "../../entity_types/product";

export const p_xymatnke38: FaireProductEntity = {
  token: "p_xymatnke38",
  type: "product",
  name: "Employee Of The Year Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/ceb804ff80833d6f64a712e1424632754d18b09f98075669605f202b8f6728db.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/33c3142a5a5ec420fdaeae677848e90519d8d4db31e9b3283dfb13179145b97e.jpeg",
    "https://cdn.faire.com/fastly/a6b37060f87c983368683f3bbd8ea9cd04d11d82061bbc1ccd503451271b933b.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/02e2901be7a21a768e13e350edf079dbef66f2517785943c3ea1e1d6e8938234.jpeg",
    "https://cdn.faire.com/fastly/72d96616e879c97688506f20c0d99f0f2733db69408bfed97c0b4e4f05ac3b6a.jpeg"
  ],
  priceDollars: 6.75,
  description: "For the employee who’s clearly running the show—these socks say Employee of the Year... and yes, everyone knows it...geez, make the rest of us look bad why don't you. 🙄\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:28.032Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
